export const getCategoryName = (arr, itemId) =>
  arr.reduce((a, item) => {
    if (a) return a;
    if (item.id === itemId) return item.name;
    if (item["categories"]) return getCategoryName(item["categories"], itemId);
    else return null;
  }, null);
